import ProgendaContext from "shared/progenda_context";

ProgendaContext.setContext("PUBLIC");
